import { LaunchSendsTab, useWaves } from "./LaunchSendsTab";
import type { FreshnessMeta } from "./api";

/** The head query: sources the freshness line and warms the Launch sends cache (one request). */
export function useCampaignsMeta(enabled: boolean): FreshnessMeta | null | undefined {
  const head = useWaves(enabled);
  return enabled ? head.data?.meta : undefined;
}

/**
 * Tab content only. ShellPage wraps this in the shell-owned ModuleViewport and
 * PermissionGate; the permission prop and `ownerName` are accepted and not read (I-7).
 * One tab today (`launch_sends`); the spec's calendar, campaigns, plays, this_week
 * and reviews tabs land with their own releases.
 */
export function CampaignsModule(_props: {
  decision: "edit" | "view" | "none";
  activeTabKey: string | null;
  areaName: string;
  ownerName?: string | null;
}) {
  return <LaunchSendsTab />;
}
